import store from '@/store'
import axios from 'axios'
import {
  Message,
  //MessageBox,
  // Loading
} from 'element-ui'

import util from '@/libs/util'

//import router from '@/router/index'
// 创建一个错误
function errorCreat(msg,jsonError) {
  const err = new Error(msg)
  errorLog(err)
  throw err
}
//
// function errorCallBack(data) {
//   const err = data
//   throw err
//   //return Promise.reject(err)
// }

// 记录和显示错误
function errorLog(err) {
  // 添加到日志
  store.dispatch('d2admin/log/add', {
    type: 'error',
    err,
    info: '数据请求异常'
  })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(err)
  }
  // 显示提示
  if (err.message == 'undefined message, exception code: parse_excel_error'){
    Message({
      message: "请上传下载模版时的对应excel文件",
      type: 'error',
      duration: 3 * 1000
    })
  }else{
    Message({
      message: err.message,
      type: 'error',
      duration: 3 * 1000
    })
  }
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 10000, // 请求超时时间
  withCredentials: true //表示跨域请求时是否需要使用凭证. 默认为false
})
// var loading;
// 请求拦截器
service.interceptors.request.use(
  config => {
    //打开遮罩层
    // loading = Loading.service({
    //   lock: true,
    //   text: "正在加载",
    //   background: "rgba(255,255,255,0.7)"
    // });
    // 在请求发送之前做一些处理
    if (!(/^https:\/\/|http:\/\//.test(config.url))) {
      const token = util.cookies.get('token')
      if (token && token !== 'undefined') {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        config.headers['X-Token'] = token
      }
    }

    return config
  },
  error => {
    // 发送失败
   // console.log(error)
    Promise.reject(error)
    //遮罩层关闭
    // loading.close();
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    //遮罩层关闭
    // loading.close();
    //console.log(response.config);
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data

    //登录fail
    // if (dataAxios == "fail") {
    //   //errorCallBack(dataAxios.data)
    //   errorCreat(`用户名或密码不正确!`);
    //   return Promise.reject(`用户名或密码不正确`)
    // }
    // if (dataAxios == "error") {
    //   //errorCallBack(dataAxios.data)
    //   errorCreat(`数据请求失败!`);
    //   return Promise.reject(`数据请求失败`)
    // }
    // if (dataAxios.jsonError) {
    //   if (dataAxios.jsonError[0]._exceptionMessageCode == "PE.CCE.USR.NotLogin") {
    //     MessageBox.confirm('登录失效，是否重新登录?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       sessionStorage.removeItem("data");
    //       sessionStorage.removeItem("asideMenuConfig");
    //       sessionStorage.removeItem("UserName");
    //       sessionStorage.removeItem("Password");
    //
    //       router.replace({
    //         path: "/login"
    //       });
    //     }).catch(() => {
    //
    //     });
    //     return Promise.reject(`登录失效`)
    //   }
    //   if (dataAxios.jsonError[0]._exceptionMessageCode == "java.net.SocketTimeoutException: connect timed out") {
    //     errorCreat(`连接超时!`);
    //     return Promise.reject(`连接超时`)
    //   } else {
    //     errorCreat(dataAxios.jsonError[0]._exceptionMessageCode);
    //     return Promise.reject(dataAxios.jsonError[0]._exceptionMessageCode)
    //   }
    // }
    // 这个状态码是和后端约定的
    const {
      jsonError
    } = dataAxios
    // 根据 code 进行判断
    if (jsonError === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      errorCreat(`${dataAxios.jsonError[0]._exceptionMessage}`,dataAxios)
    }
  },
  error => {
    //遮罩层关闭
    // loading.close();
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }
    errorLog(error)
    return Promise.reject(error)
  }
)

export default service
